const CYRILLIC_TO_LATIN_PLATE_MAP = {
  А: 'A',
  В: 'B',
  Е: 'E',
  К: 'K',
  М: 'M',
  Н: 'H',
  О: 'O',
  Р: 'P',
  С: 'C',
  Т: 'T',
  У: 'Y',
  Х: 'X'
}

const DEBT_AMOUNT_PATHS = [
  'amount',
  'debt_amount',
  'debtAmount',
  'should_pay',
  'shouldPay',
  'data.amount',
  'data.debt_amount',
  'data.debtAmount',
  'data.should_pay',
  'data.shouldPay',
  'data.debt.amount',
  'data.debt.debt_amount',
  'data.debt.should_pay'
]

const RESOLVED_PLATE_PATHS = [
  'plate_number',
  'plateNumber',
  'car_number',
  'carNumber',
  'number',
  'data.plate_number',
  'data.plateNumber',
  'data.car_number',
  'data.carNumber',
  'data.number'
]

const readByPath = (source, path) =>
  path
    .split('.')
    .reduce(
      (currentValue, key) =>
        currentValue != null ? currentValue[key] : undefined,
      source
    )

const toFiniteNumber = (value) => {
  if (value == null || value === '') return null

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }

  const normalizedValue = String(value).trim().replace(/\s+/g, '').replace(',', '.')
  if (!normalizedValue) return null

  const parsed = Number(normalizedValue)
  return Number.isFinite(parsed) ? parsed : null
}

// TODO Должно происходить на бэке?
export const normalizeManualPlateNumber = (value) =>
  Array.from(String(value || '').toUpperCase())
    .map((char) => CYRILLIC_TO_LATIN_PLATE_MAP[char] || char)
    .join('')
    .replace(/[^A-Z0-9]/g, '')

export const extractManualDebtAmount = (payload) => {
  for (const path of DEBT_AMOUNT_PATHS) {
    const amount = toFiniteNumber(readByPath(payload, path))
    if (amount != null) {
      return Math.max(amount, 0)
    }
  }

  return 0
}

export const resolveManualPaymentPlate = ({ inputPlate = '', payload }) => {
  for (const path of RESOLVED_PLATE_PATHS) {
    const plate = normalizeManualPlateNumber(readByPath(payload, path))
    if (plate) {
      return plate
    }
  }

  return normalizeManualPlateNumber(inputPlate)
}
